function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Card, Empty, Search } from "../../components/analytics-kit";
import StatusFilter from "../../components/status-filter";
import { Loader, ChartLoader } from "../../components/loaders";
import Error from "../../components/error";
import Chart from "../../components/chart";
import { num, fetchSales, bucketFor, deltaOfPaced, comparisonQs, accountLensKv, readAcctLens, writeAcctLens, rangeLabelFor, RANGES, titleCase, resolveBusinessModel } from "../sales/territory-common";
import { Link } from "react-router-dom";
import { AccountFilterControl, AccountFilterBanner } from "../sales/account-filter";
import account from "../../data/account";
import { hasTenantFeature } from "../../functions/tenant-features";
import compLabel from "../../functions/comp-label";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { usd0, usdShort, displayTitle, explorerRows, CappedCard, ListRow, PPRibbon, salesByPeriodData, salesByPeriodOptions, bucketWord } from "../sales/product-detail";

// territory-common deltas ({text, dir, pct}) in the kit's shape.
const kitDelta = d => d && d.pct != null ? {
  dir: d.dir,
  pct: d.pct
} : null;

/*
 * Series (family) page: the grain above the product page, opened from the
 * Explorer's series grain. Header + ribbon, sales by month beside top dealers,
 * then the main section: EVERY product in the series (sold or not) from
 * /sales/explorer/products/{range}?family=&includeUnsold=true, falling back to the
 * member SKUs that sold (/sales/products?family=) while that endpoint is not
 * deployed. All /sales/* calls are scoped by ?family= (title tenants match the
 * leading title-word; sku_root tenants match the SKU root).
 */

const COLS = [{
  k: "product",
  l: "Product"
}, {
  k: "category",
  l: "Type"
}, {
  k: "avgPrice",
  l: "Avg price sold",
  n: true
}, {
  k: "revenue",
  l: "Revenue",
  n: true
}, {
  k: "units",
  l: "Units",
  n: true
}, {
  k: "dealers",
  l: "Dealers",
  n: true
}, {
  k: "views",
  l: "Website views",
  n: true
}];

// One shape for both sources (explorer rows and the member-SKU fallback).
function normExplorer(r) {
  const revenue = Number(r.revenue != null ? r.revenue : r.totalAmount) || 0;
  const units = Number(r.units != null ? r.units : r.quantity) || 0;
  return {
    productId: String(r.productId != null ? r.productId : r.id),
    sku: r.sku || r.productId || r.id,
    title: displayTitle(r.title) || "",
    rawTitle: r.title,
    category: r.category && r.category !== "(uncategorized)" ? displayTitle(r.category) : "",
    imageLink: r.imageLink || null,
    avgPrice: r.avgPrice != null ? Number(r.avgPrice) || 0 : units > 0 ? revenue / units : 0,
    revenue,
    units,
    dealers: r.dealers != null ? Number(r.dealers) || 0 : r.customers != null ? Number(r.customers) || 0 : null,
    views: r.views != null ? Number(r.views) || 0 : null
  };
}
function csvCell(v) {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
class FamilyDetailComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setAcctLens", (mode, ids) => {
      writeAcctLens((account.get() || {}).tenantId, mode, ids);
      this.setState({
        acctMode: mode,
        acctIds: ids,
        data: null,
        error: false
      }, () => this.load());
    });
    _defineProperty(this, "removeAcct", id => this.setAcctLens(this.state.acctMode, this.state.acctIds.filter(x => String(x) !== String(id))));
    _defineProperty(this, "clearAcct", () => this.setAcctLens(this.state.acctMode, []));
    _defineProperty(this, "back", () => this.props.history.push(`/Products/${this.range()}?grain=families`));
    _defineProperty(this, "openProduct", (id, title) => id && this.props.history.push({
      pathname: `/Products/${this.range()}/product/${encodeURIComponent(id)}`,
      state: {
        title,
        family: this.family()
      }
    }));
    _defineProperty(this, "openDealer", accountNumber => accountNumber && this.props.history.push(`/Territory/${this.range()}/customer/${encodeURIComponent(accountNumber)}`));
    const lens = readAcctLens((account.get() || {}).tenantId);
    this.state = {
      data: null,
      error: false,
      status: [],
      comp: getGlobalComp("prev_year"),
      catalog: undefined,
      filter: "all",
      q: "",
      sort: {
        k: "revenue",
        dir: -1
      },
      acctMode: lens.mode,
      acctIds: lens.ids,
      acctSource: []
    };
    this._alive = true;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange();
  }
  family() {
    return decodeURIComponent(this.props.params && this.props.params.family || "");
  }
  statusQs() {
    const st = (this.state.status || []).join(",");
    return st ? "&status=" + encodeURIComponent(st) : "";
  }
  acctQs() {
    const kv = accountLensKv(this.state.acctMode, this.state.acctIds);
    return kv ? "&" + kv : "";
  }
  async loadAcctSource() {
    try {
      const rows = await fetchSales(`/sales/customers/${this.range()}?top=200`);
      if (this._alive) this.setState({
        acctSource: Array.isArray(rows) ? rows : []
      });
    } catch (e) {/* optional */}
  }
  componentDidMount() {
    // Retail workspaces have no B2B accounts or order statuses: the two filters are not shown.
    resolveBusinessModel().then(m => {
      if (m) this.setState({
        businessModel: m
      });
    }).catch(() => {});
    this.load();
    this.loadAcctSource();
    this._tok = subscribePeriod(({
      range,
      comp
    }) => {
      if (!this._alive) return;
      if (comp && comp !== this.state.comp) this.setState({
        comp
      });
      const target = `/Products/${range}/family/${encodeURIComponent(this.family())}`;
      if (window.location.pathname === target) this.setState({
        data: null,
        error: false
      }, () => this.load());else this.props.history.push(target);
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._tok);
  }
  componentDidUpdate(prev) {
    const a = `${(prev.params || {}).range}|${(prev.params || {}).family}`;
    const b = `${(this.props.params || {}).range}|${(this.props.params || {}).family}`;
    if (a !== b) {
      this.setState({
        data: null,
        error: false
      });
      this.load();
    }
  }
  async load() {
    const range = this.range();
    const fam = encodeURIComponent(this.family());
    const cmp = comparisonQs(range, false, this.state.comp);
    const sq = this.statusQs();
    this.setState({
      catalog: undefined
    });
    // Every product in the series, including unsold ones (new endpoint; fails soft
    // to the member-SKU list below).
    fetchSales(`/sales/explorer/products/${range}?family=${fam}&includeUnsold=true&top=500${sq}${this.acctQs()}`).then(r => {
      const rows = explorerRows(r);
      if (this._alive) this.setState({
        catalog: rows.length ? rows.map(normExplorer) : null
      });
    }).catch(() => {
      if (this._alive) this.setState({
        catalog: null
      });
    });
    try {
      const [totals, trend, members, dealers] = await Promise.all([fetchSales(`/sales/totals/${range}?family=${fam}${cmp}${sq}${this.acctQs()}`), fetchSales(`/sales/trend/${range}?bucket=${bucketFor(range)}&family=${fam}${cmp}${sq}${this.acctQs()}`), fetchSales(`/sales/products/${range}?family=${fam}&top=100${sq}${this.acctQs()}`), fetchSales(`/sales/customers/${range}?family=${fam}&top=50${sq}${this.acctQs()}`).catch(() => [])]);
      if (this._alive) this.setState({
        data: {
          totals: totals || {},
          trend: trend || [],
          members: members || [],
          dealers: dealers || []
        }
      });
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  setSort(k) {
    this.setState(s => ({
      sort: s.sort.k === k ? {
        k,
        dir: -s.sort.dir
      } : {
        k,
        dir: k === "product" || k === "category" ? 1 : -1
      }
    }));
  }
  downloadCsv(rows) {
    const head = ["SKU", "Product", "Type", "Avg price sold", "Revenue", "Units", "Dealers", "Website views"];
    const lines = [head.join(",")].concat(rows.map(r => [r.sku, r.title, r.category, r.avgPrice ? Math.round(r.avgPrice) : "", Math.round(r.revenue), r.units, r.dealers == null ? "" : r.dealers, r.views == null ? "" : r.views].map(csvCell).join(",")));
    const blob = new Blob([lines.join("\n")], {
      type: "text/csv;charset=utf-8"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `series-${this.family().replace(/[^\w-]+/g, "_")}-${this.range()}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
  renderCatalog(fallbackRows) {
    const {
      catalog,
      filter,
      q,
      sort
    } = this.state;
    const loading = catalog === undefined;
    const full = Array.isArray(catalog);
    const all = full ? catalog : fallbackRows;
    const selling = all.filter(r => r.revenue > 0 || r.units > 0);
    const unsold = all.length - selling.length;
    const ql = q.trim().toLowerCase();
    let rows = filter === "selling" ? selling : filter === "unsold" ? all.filter(r => !(r.revenue > 0 || r.units > 0)) : all;
    if (ql) rows = rows.filter(r => `${r.sku} ${r.title} ${r.productId}`.toLowerCase().includes(ql));
    const key = r => sort.k === "product" ? `${r.sku} ${r.title}`.toLowerCase() : sort.k === "category" ? (r.category || "").toLowerCase() : Number(r[sort.k]) || 0;
    rows = rows.slice().sort((a, b) => {
      const x = key(a),
        y = key(b);
      return (x < y ? -1 : x > y ? 1 : 0) * sort.dir;
    });
    const showViews = all.some(r => r.views != null);
    const showDealers = all.some(r => r.dealers != null);
    const cols = COLS.filter(c => (c.k !== "views" || showViews) && (c.k !== "dealers" || showDealers));
    const isMfg = hasTenantFeature("territoryRep");
    const pill = (v, l, n) => /*#__PURE__*/React.createElement("button", {
      type: "button",
      key: v,
      className: `pp-pill${filter === v ? " on" : ""}`,
      onClick: () => this.setState({
        filter: v
      })
    }, l, " ", /*#__PURE__*/React.createElement("span", {
      className: "n"
    }, num(n)));
    return /*#__PURE__*/React.createElement(Card, {
      title: "Every product in this series",
      span: 12,
      cls: "pp-card pp-catalog",
      hint: full ? `${num(all.length)} products, including ones with no sales yet` : loading ? "loading the full list" : `${num(all.length)} products that sold in this period`
    }, /*#__PURE__*/React.createElement("div", {
      className: "pp-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "pp-pills"
    }, pill("all", "All", all.length), pill("selling", "Selling", selling.length), full ? pill("unsold", "No sales", unsold) : null), /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search SKU or name"
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "pp-btn",
      disabled: !rows.length,
      onClick: () => this.downloadCsv(rows)
    }, "Download CSV")), rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "tblwrap pp-scroll"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table pp-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, cols.map(c => /*#__PURE__*/React.createElement("th", {
      key: c.k,
      className: `pp-sort${c.n ? " n" : ""}${sort.k === c.k ? " on" : ""}`,
      onClick: () => this.setSort(c.k)
    }, c.k === "dealers" && !isMfg ? "Customers" : c.l, sort.k === c.k ? sort.dir < 0 ? " ▾" : " ▴" : "")))), /*#__PURE__*/React.createElement("tbody", null, rows.map(r => {
      const sold = r.revenue > 0 || r.units > 0;
      return /*#__PURE__*/React.createElement("tr", {
        key: r.productId,
        className: `clickable${sold ? "" : " pp-unsold"}`,
        onClick: () => this.openProduct(r.productId, r.rawTitle),
        title: `Open ${r.title || r.sku}`
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
        className: "pp-prod"
      }, r.imageLink ? /*#__PURE__*/React.createElement("img", {
        className: "pp-thumb",
        src: r.imageLink,
        alt: "",
        loading: "lazy",
        onError: e => {
          e.target.style.visibility = "hidden";
        }
      }) : /*#__PURE__*/React.createElement("span", {
        className: "pp-thumb empty",
        "aria-hidden": "true"
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "weekend")), /*#__PURE__*/React.createElement("span", {
        className: "pp-prod-txt"
      }, /*#__PURE__*/React.createElement("b", null, r.title ? `${r.sku} · ${r.title}` : r.sku), sold ? null : /*#__PURE__*/React.createElement("span", {
        className: "pp-row-sub"
      }, "No sales in this period")))), /*#__PURE__*/React.createElement("td", null, r.category), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, r.avgPrice ? usd0(r.avgPrice) : ""), /*#__PURE__*/React.createElement("td", {
        className: "n strong"
      }, sold ? usd0(r.revenue) : ""), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, sold ? num(r.units) : ""), showDealers ? /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, r.dealers ? num(r.dealers) : "") : null, showViews ? /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, r.views ? num(r.views) : "") : null);
    })))) : /*#__PURE__*/React.createElement(Empty, null, ql ? "No products match that search." : "No products in this view."), rows.length ? /*#__PURE__*/React.createElement("p", {
      className: "pp-foot"
    }, "Showing ", num(rows.length), " of ", num(all.length)) : null);
  }
  render() {
    const {
      data,
      error
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, {
      onRetry: () => this.setState({
        error: false,
        data: null
      }, () => this.load())
    });
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const {
      totals,
      trend,
      members,
      dealers
    } = data;
    const family = this.family();
    const range = this.range();
    const bucket = bucketFor(range);
    const chart = salesByPeriodData(trend, bucket, this.state.comp);
    const isMfg = hasTenantFeature("territoryRep");
    const buyer = isMfg ? "dealers" : "customers";
    const memberRows = members.map(normExplorer);
    const catalog = Array.isArray(this.state.catalog) ? this.state.catalog : null;
    const base = catalog || memberRows;
    const count = catalog ? catalog.length : members.length >= 100 ? "100+" : members.length;
    // Top titles by revenue (distinct), and the most common product type.
    const titles = [];
    base.slice().sort((a, b) => b.revenue - a.revenue).forEach(r => {
      const t = r.title && r.title.replace(new RegExp("^" + family.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s+", "i"), "");
      if (t && titles.indexOf(t) < 0 && titles.length < 2) titles.push(t);
    });
    const catCounts = {};
    base.forEach(r => {
      if (r.category) catCounts[r.category] = (catCounts[r.category] || 0) + 1;
    });
    const topCat = Object.keys(catCounts).sort((a, b) => catCounts[b] - catCounts[a])[0];
    const compWord = (compLabel(this.state.comp) || "").toLowerCase().replace("previous", "last").replace("unavailable", "");
    const orders = Number(totals.orders) || 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view territory-detail products-workspace wa-view pp-view"
    }, /*#__PURE__*/React.createElement("header", {
      className: "pp-shead"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "pp-crumbs"
    }, /*#__PURE__*/React.createElement(Link, {
      to: `/Products/${range}`
    }, "Products"), " \xB7 ", /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        this.back();
      }
    }, "Series")), /*#__PURE__*/React.createElement("h1", null, "Series ", family, titles.length ? ` · ${titles.join(", ")}` : ""), /*#__PURE__*/React.createElement("span", {
      className: "sub"
    }, [`${count} product${count === 1 ? "" : "s"}${topCat ? `, mostly ${topCat.toLowerCase()}` : ""}`, rangeLabelFor(range, RANGES)].join(" · "))), this.state.businessModel === "retail" ? null : /*#__PURE__*/React.createElement("span", {
      className: "pp-filters"
    }, /*#__PURE__*/React.createElement(StatusFilter, {
      range: range,
      value: this.state.status,
      onChange: v => this.setState({
        status: v,
        data: null,
        error: false
      }, () => this.load())
    }), /*#__PURE__*/React.createElement(AccountFilterControl, {
      customers: this.state.acctSource || [],
      mode: this.state.acctMode,
      ids: this.state.acctIds,
      onApply: this.setAcctLens
    }))), this.state.acctIds && this.state.acctIds.length > 0 && /*#__PURE__*/React.createElement(AccountFilterBanner, {
      customers: this.state.acctSource || [],
      mode: this.state.acctMode,
      ids: this.state.acctIds,
      onRemove: this.removeAcct,
      onClear: this.clearAcct
    }), /*#__PURE__*/React.createElement(PPRibbon, {
      tiles: [{
        l: "Revenue",
        v: usdShort(totals.totalAmount),
        d: kitDelta(deltaOfPaced(totals.totalAmount, totals.prevTotalAmount, range)),
        ds: compWord ? `vs ${compWord}` : ""
      }, {
        l: "Units",
        v: num(totals.quantity),
        d: kitDelta(deltaOfPaced(totals.quantity, totals.prevQuantity, range))
      }, {
        l: `${titleCase(buyer)} buying`,
        v: num(totals.customers),
        s: `${num(orders)} orders`
      }, {
        l: "Average order",
        v: orders > 0 ? usd0((Number(totals.totalAmount) || 0) / orders) : "None yet",
        s: "across the series"
      }]
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: `Sales by ${bucketWord(bucket)}`,
      hint: "hover for values",
      span: 8,
      cls: "pp-card"
    }, chart ? /*#__PURE__*/React.createElement(Chart, {
      width: "100%",
      height: "260px",
      chartType: "ComboChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chart,
      options: salesByPeriodOptions(chart.withPrev)
    }) : /*#__PURE__*/React.createElement(Empty, null, "Not enough sales in this period to chart.")), dealers.length ? /*#__PURE__*/React.createElement(CappedCard, {
      title: `Top ${buyer}`,
      rows: dealers
    }, rows => rows.map(d => /*#__PURE__*/React.createElement(ListRow, {
      key: d.accountNumber,
      name: d.name || d.accountNumber,
      sub: [d.city, d.region].filter(Boolean).join(", ") || d.accountNumber,
      value: usd0(d.totalAmount),
      onClick: isMfg ? () => this.openDealer(d.accountNumber) : undefined,
      title: isMfg ? `Open ${d.name}` : undefined
    }))) : /*#__PURE__*/React.createElement(Card, {
      title: `Top ${buyer}`,
      span: 4,
      cls: "pp-card"
    }, /*#__PURE__*/React.createElement(Empty, null, "No ", buyer, " bought this series in this period.")), this.renderCatalog(memberRows)));
  }
}
export default withRouter(FamilyDetailComponent);